
import { Checkbox } from "@/components/ui/checkbox";
import { Filters } from "./types";

interface CRMFilterPanelProps {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  totalRecords: number;
  filteredRecords: number;
}

export const CRMFilterPanel = ({ 
  filters, 
  setFilters, 
  totalRecords, 
  filteredRecords 
}: CRMFilterPanelProps) => {
  
  const handleMembershipTypeChange = (type: string) => {
    setFilters(prev => {
      const newMembershipTypes = prev.membershipTypes.includes(type)
        ? prev.membershipTypes.filter(t => t !== type)
        : [...prev.membershipTypes, type];
      
      return {
        ...prev,
        membershipTypes: newMembershipTypes
      };
    });
  };

  const handleFilterChange = (filterKey: keyof Omit<Filters, 'membershipTypes' | 'searchTerm' | 'startDate' | 'endDate' | 'dateField'>) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: !prev[filterKey]
    }));
  };

  return (
    <div className="mb-4 p-4 border rounded-md bg-muted/20">
      <h3 className="text-sm font-semibold mb-3">Filtres de type</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-active"
            checked={filters.membershipTypes.includes("active")}
            onCheckedChange={() => handleMembershipTypeChange("active")}
          />
          <label
            htmlFor="filter-active"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Actif
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-benefactor"
            checked={filters.membershipTypes.includes("benefactor")}
            onCheckedChange={() => handleMembershipTypeChange("benefactor")}
          />
          <label
            htmlFor="filter-benefactor"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Bienfaiteur
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-donor"
            checked={filters.membershipTypes.includes("donor")}
            onCheckedChange={() => handleMembershipTypeChange("donor")}
          />
          <label
            htmlFor="filter-donor"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Donateur non membre
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-signataires"
            checked={filters.showSignatories}
            onCheckedChange={() => handleFilterChange('showSignatories')}
          />
          <label
            htmlFor="filter-signataires"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Signataire non membre
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-newsletter"
            checked={filters.showNewsletter}
            onCheckedChange={() => handleFilterChange('showNewsletter')}
          />
          <label
            htmlFor="filter-newsletter"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Abonnés newsletter
          </label>
        </div>
        
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="filter-donors"
            checked={filters.showDonors}
            onCheckedChange={() => handleFilterChange('showDonors')}
          />
          <label
            htmlFor="filter-donors"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Donateur membre
          </label>
        </div>
      </div>

      <h3 className="text-sm font-semibold mb-3 mt-4">Statut de paiement</h3>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {[
          { id: "paid", label: "Payé" },
          { id: "pending_payment", label: "En attente de paiement" },
          { id: "pending_verification", label: "En attente de vérification" },
          { id: "pending", label: "En attente" },
        ].map(status => (
          <div key={status.id} className="flex items-center space-x-2">
            <Checkbox
              id={`filter-payment-${status.id}`}
              checked={filters.paymentStatuses.includes(status.id)}
              onCheckedChange={() => {
                setFilters(prev => ({
                  ...prev,
                  paymentStatuses: prev.paymentStatuses.includes(status.id)
                    ? prev.paymentStatuses.filter(s => s !== status.id)
                    : [...prev.paymentStatuses, status.id]
                }));
              }}
            />
            <label
              htmlFor={`filter-payment-${status.id}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {status.label}
            </label>
          </div>
        ))}
      </div>
      
      <div className="mt-4 text-sm text-muted-foreground">
        {filteredRecords} enregistrements affichés sur {totalRecords}
      </div>
    </div>
  );
};
